import { BankingTab, MyFinanceTabs } from "@/modules/dashboard/common/enum";
import type { ITabItemsProps } from "@/shared/common/types";

export const getMyFinanceTabItems = ({ t }: ITabItemsProps) => [
  {
    value: MyFinanceTabs.Accounts,
    label: t("dashboard.myFinances.accounts"),
    dataId: "account-tab",
    disabled: false,
  },
  {
    value: MyFinanceTabs.Cards,
    label: t("dashboard.myFinances.cards"),
    dataId: "card-tab",
    disabled: false,
  },
  {
    value: MyFinanceTabs.Deposits,
    label: t("dashboard.myFinances.deposits"),
    dataId: "deposit-tab",
    disabled: false,
  },
  {
    value: MyFinanceTabs.Loans,
    label: t("dashboard.myFinances.loans"),
    dataId: "loan-tab",
    disabled: false,
  },
  {
    value: MyFinanceTabs.Stocks,
    label: t("dashboard.myFinances.stocks"),
    dataId: "stock-tab",
    disabled: false,
  },
  {
    value: MyFinanceTabs.Bonds,
    label: t("dashboard.myFinances.bonds"),
    dataId: "bond-tab",
    disabled: false,
  }];

export const getBankingTabItems = ({ t }: ITabItemsProps) => [
  {
    value: BankingTab.Transactions,
    label: t("dashboard.banking.transfers"),
    dataId: "transfer-tab",
    disabled: false,
  },
  {
    value: BankingTab.Templates,
    label: t("dashboard.banking.templates"),
    dataId: "template-tab",
    disabled: false,
  }
];
